import { type BentoCard } from './bento-grid';

export const GUARANTEE_CARDS_AR: BentoCard[] = [
  {
    id: 'apply',
    title: 'قدّم مرة وحدة. وخلاص.',
    description:
      'عبّي طلب من ٣٠ ثانية. وأول ما يبدأ اشتراكك تصير محمي. لا مفاوضات على أرقام، ولا عقود تلف بين المحامين.',
    modal: {
      eyebrow: 'الخطوة ١ · قدّم',
      headline: 'بيننا وبينك بس طلب من ٣٠ ثانية',
      paragraphs: [
        'ما نطلب منك تفاوض على أرقام، ولا توقيع أوراق طويلة. خبّرنا باختصار عن نظام الدعم عندك، ونؤكّد تسجيلك عبر الإيميل، وتصير مشترك.',
        'من أول يوم في اشتراكك المدفوع مع Open، يبدأ عدّاد الـ ١٢٠ يوم. بدون ورشة انطلاق، ولا لجنة أهداف، ولا سطر واحد بالخط الصغير.',
      ],
      bullets: [
        'نموذج تأهيل ياخذ ٣٠ ثانية',
        'تأكيد التسجيل خلال يومين عمل',
        'حمايتك تبدأ من أول يوم في اشتراكك المدفوع',
        'لا أرقام ولا أهداف نتفاوض عليها',
      ],
    },
  },
  {
    id: 'run-in-prod',
    title: 'استخدم Open مع عملائك',
    description:
      'استخدم Open على حركة عملائك الحقيقية حتى ١٢٠ يوم. لا رقم تلاحقه ولا هدف تجري خلفه. بس الشغل اللي يهمّك.',
    modal: {
      eyebrow: 'الخطوة ٢ · استخدمه',
      headline: '١٢٠ يوم. حركة حقيقية. ولا هدف واحد.',
      paragraphs: [
        'لا عروض في بيئة مغلقة، ولا تذاكر منتقاة بعناية. Open يتولّى محادثات عملائك الحقيقية على كل قناة تشغّلها: صوت، دردشة، إيميل، WhatsApp، سوشيال.',
        'لا نسبة أتمتة، ولا حد أدنى لـ CSAT لازم توصله. الضمان معلّق على شي واحد: رضاك. وإذا ما نجح مع فريقك، الاسترجاع حقّك.',
      ],
      bullets: [
        'حركة إنتاج كاملة على كل قناة موصولة',
        'سجل تدقيق لكل محادثة مع تتبّع لخطوات التفكير',
        'لا هدف أتمتة، ولا CSAT، ولا نسبة حل ذاتي لازم تحققها',
        'توقفه في أي لحظة، وما في شي يقيّدك',
      ],
    },
  },
  {
    id: 'we-refund',
    title: 'استرجاع، بدون أسئلة',
    description:
      'مو راضي ١٠٠٪ خلال ١٢٠ يوم؟ خبّرنا مرة وحدة، ونحوّل لك كل ريال دفعته على Open، حتى ٧,٥ مليون ⃁.',
    modal: {
      eyebrow: 'الخطوة ٣ · الضمان',
      headline: 'كلمة منك، وتحويل بنكي خلال ٣٠ يوم.',
      paragraphs: [
        'لا تبرير مطلوب. ولا رقم لازم تحققه. إذا ما كنت راضي ١٠٠٪ خلال أول ١٢٠ يوم، خبّرنا مرة وحدة ويوصل الاسترجاع لحسابك البنكي.',
        'وما نطالبك بشي بعدها. لا خط صغير، ولا عبارة «مو هذا اللي قصدناه». الشروط قصيرة، بلغة واضحة، وموقّعة من الطرفين من البداية.',
      ],
      bullets: [
        'كل ريال دفعته على Open يرجع لك، حتى ٧,٥ مليون ⃁',
        'تحويل بنكي خلال ٣٠ يوم من طلب الاسترجاع',
        'تحتفظ بكل سير عمل ودليل تشغيل وتعليمات بنيناها',
        'لا جدال مع المحامين؛ الشروط موقّعة من البداية',
      ],
    },
  },
  {
    id: 'no-lock-in',
    title: 'لا قيود، أبداً',
    description:
      'اطلع في أي وقت. بياناتك وسير عملك وقاعدة معرفتك وتعليماتك ملكك، تصدّرها بصيغ مفتوحة تشتغل فعلاً بمكان ثاني.',
    modal: {
      eyebrow: 'القيد · ولا واحد',
      headline: 'بياناتك، وقرارك، دائماً',
      paragraphs: [
        'أغلب مزوّدي AI يراهنون بصمت على أن تكلفة التبديل تخليك عندهم. نحن لا. كل سير عمل وتعليمات ومصدر معرفة وسجل محادثات يبقى في حسابك، وتصدّره بصيغ مفتوحة في أي وقت.',
        'ألغِ في نص العقد، ونخصّص جلسة إنهاء الخدمة بالكامل عشان نساعد فريقك ينتقل لأي حل يجي بعدنا.',
      ],
      bullets: [
        'صيغ مفتوحة لكل تصدير بيانات (JSON، CSV، Markdown)',
        'قاعدة المعرفة وسير العمل والتعليمات كلها قابلة للنقل',
        'تصدير سجلات المحادثات مع تتبّع كامل لخطوات التفكير',
        'لا بند واحد يحتجز بياناتك، في أي سطر من العقد',
      ],
    },
  },
  {
    id: 'real-team',
    title: 'خلفه فريق حقيقي',
    description:
      'مو قناة Discord. تحصل على مهندسي حلول بأسمائهم، ومدرّبي AI، وقائد مشروع يتولّون تشغيلك من أوله لآخره.',
    modal: {
      eyebrow: 'بشر · حقيقيون',
      headline: 'أشخاص بأسمائهم، مو طابور انتظار',
      paragraphs: [
        'الخدمة الذاتية تكفي وأنت تجرّب، بس ما تكفي وعميلك على الخط ومشكلته قدامه. من الانطلاق حتى التشغيل اليومي، تحصل على أشخاص بأسمائهم من Open يتولّون حسابك.',
        'يحضرون اجتماعاتك اليومية، ويشاركونك الـ QBRs، ويُطلقون تعديلات سير العمل جنب فريقك، عادةً خلال يوم واحد.',
      ],
      bullets: [
        'مهندس حلول ومدرّب AI مخصّصان بالاسم لكل حساب',
        'تعديلات سير العمل والتعليمات تنزل في نفس اليوم',
        'مراجعات أعمال ربع سنوية مع القيادة',
        'قناة Slack/Teams مباشرة مع فريق حسابك',
      ],
    },
  },
  {
    id: 'security',
    title: 'الأمان من اليوم الأول',
    description:
      'حاصل على شهادتي SOC 2 Type II وISO 27001، متوافق مع GDPR، وجاهز لـ HIPAA وPCI. بياناتك مشفّرة، ومعزولة بالكامل في نطاقك الخاص، ولا تُستخدم أبداً لتدريب نماذج مشتركة.',
    modal: {
      eyebrow: 'الأمان · بشكل تلقائي',
      headline: 'أمان بمستوى المؤسسات من أول تذكرة',
      paragraphs: [
        'الامتثال مو بند مؤجل على خارطة الطريق، جاهز من البداية. Open حاصل رسمياً على شهادتي SOC 2 Type II وISO 27001، ومتوافق مع GDPR، وقابل للتهيئة لدعم متطلبات HIPAA وPCI.',
        'بياناتك مشفّرة أثناء النقل وفي التخزين، ومعزولة بالكامل في نطاقك الخاص، ولا تُستخدم في أي وقت لتدريب نماذج أساسية مشتركة.',
      ],
      bullets: [
        'شهادة SOC 2 Type II مع تدقيق سنوي',
        'شهادة ISO 27001',
        'إعدادات متوافقة مع GDPR وجاهزة لمتطلبات HIPAA وPCI',
        'عزل كامل للنطاق؛ بياناتك لا تُستخدم لتدريب نماذج مشتركة',
        'خيار الاستضافة الذاتية للقطاعات المنظّمة',
      ],
    },
  },
];

export const CHALLENGE_AR = {
  heading: 'ضمان استرجاع حتى ٧,٥ مليون ⃁.',
  // Two paragraphs: the 120-day promise stands alone, then the question and
  // its answer.
  subtitle: [
    'أول ١٢٠ يوم كاملة وأنت محمي.',
    'مو راضي ١٠٠٪؟ نرجّع لك كل ريال دفعته على Open، حتى ٧,٥ مليون ⃁.',
  ],
  cta: 'شوف التفاصيل',
};
